import { Fragment } from 'react'
import { ScaleTypes } from '../../utils/enum'
import { formatNumberOnUnitMeasure } from '../../utils/helper'
import { COLOR_MAP } from '../../utils/theme'

const MapLegend = ({
  legendRange,
  colors,
  scaleType,
  isTheme = false,
  divBinnedMidValue = null,
  unitMeasure,
  decimals,
  noDataColor,
}) => {
  let legendRangeDivs = []
  if (scaleType === ScaleTypes.Categorical) {
    legendRangeDivs =
      legendRange &&
      legendRange.length > 0 &&
      legendRange.map((item, index) => (
        <div className="map-legand-label" key={`${item}-${index}`}>
          {item == 1 ? 'Yes' : 'No'}
        </div>
      ))
  } else {
    legendRangeDivs =
      legendRange &&
      legendRange.length > 0 &&
      legendRange.map((item, index) => {
        if (
          divBinnedMidValue !== null &&
          legendRange.length % 2 === 0 &&
          index === legendRange.length / 2 - 1
        ) {
          return (
            <Fragment key={`${item}-${index}`}>
              <div className="map-legand-label">
                {/* format number to K,M,B etc and round off decimals */}
                {item !== '' && item !== undefined && item !== null
                  ? unitMeasure
                    ? formatNumberOnUnitMeasure({
                      value: item,
                      unitMeasure,
                      decimals,
                    })
                    : Intl.NumberFormat('en', { notation: 'compact' }).format(
                        item
                      )
                  : ''}
              </div>
              <div
                className="map-legand-label mid-value"
                key={divBinnedMidValue}
              >
                {/* format number to K,M,B etc and round off decimals */}
                {divBinnedMidValue !== '' &&
                divBinnedMidValue !== undefined &&
                divBinnedMidValue !== null
                  ? unitMeasure
                    ? formatNumberOnUnitMeasure({
                      value: divBinnedMidValue,
                      unitMeasure,
                      decimals,
                    })
                    : Intl.NumberFormat('en', { notation: 'compact' }).format(
                        divBinnedMidValue
                      )
                  : ''}
              </div>
            </Fragment>
          )
        } else {
          return (
            <div className="map-legand-label" key={`${item}-${index}`}>
              {/* format number to K,M,B etc and round off decimals */}
              {item !== '' && item !== undefined && item !== null
                ? unitMeasure
                  ? formatNumberOnUnitMeasure({
                    value: item,
                    unitMeasure,
                    decimals,
                  })
                  : Intl.NumberFormat('en', { notation: 'compact' }).format(
                      item
                    )
                : ''}
            </div>
          )
        }
      })
  }

  let colorsDiv = []
  if (scaleType === ScaleTypes.Categorical) {
    const categoryColors = colors.slice(0, legendRange.length)
    colorsDiv =
      categoryColors &&
      categoryColors.length > 0 &&
      categoryColors.map((item) => (
        <div className="map-legand-color" key={`color-${item}`}>
          <div className="map-legand" style={{ background: item }}></div>
        </div>
      ))
  } else {
    colorsDiv =
      colors &&
      colors.length > 0 &&
      colors.map((item) => (
        <div className="map-legand-color" key={`color-${item}`}>
          <div className="map-legand" style={{ background: item }}></div>
        </div>
      ))
  }

  return (
    <div
      className={
        isTheme
          ? scaleType === ScaleTypes.Categorical
            ? 'map-legand-components legend-bins-2'
            : `map-legand-components legend-bins-${colors.length}`
          : 'map-legand-components'
      }
      style={{ padding: '0px 0px 16px 0px' }}
    >
      <div className="map-legand-row">
        <div className="map-legand-label">No data </div>
        {legendRangeDivs}
      </div>
      <div className="map-legand-row">
        <div className="map-legand-color">
          <div
            className="map-legand line1"
            style={{ background: noDataColor }}
          ></div>
        </div>
        {colorsDiv}
      </div>
    </div>
  )
}
export default MapLegend
